import axios from './../axios';
import util from './util';
const apiPath = 'api/v2/user-notifications';

const userNotificationApi = {
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    countByChatrooms: queryStr => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/count-by-chatrooms?${queryStr}`
        );
    },
    countByCarerooms: queryStr => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/count-by-carerooms?${queryStr}`
        );
    },
    countNotifByMemberId: topicKey => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/count-by-current-user?topicKey=${topicKey}`
        );
    },
    countNotifByNonNullAdminId: topicKey => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/count-by-non-null-admin-id?topicKey=${topicKey}`
        );
    },
    latest: (memberId, topicKey) => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/latest/${memberId}/${topicKey}`
        );
    },
    ack: id => {
        return axios.delete(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/remove/${id}`
        );
    },
    multipleAck: ids => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/multiple-remove`,
            {
                ids
            }
        );
    },
    ackAll: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/remove-all`,
            {
                ...entity
            }
        );
    }
};

export default userNotificationApi;
